import { useEffect, useMemo, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import TableContainer from "./TableContainer.jsx";
import Header from "../Header.jsx";
import RouteMap from "../route-components/RouteMap.jsx";
import { useContextValues } from "../../context/RouteDataContext.jsx";

const toArray = (value) => (Array.isArray(value) ? value : Object.values(value || {}));

const joinWithAnd = (items) => {
  if (items.length <= 2) return items.join(" and ");

  return `${items.slice(0, -1).join(", ")}, and ${items[items.length - 1]}`;
};

export default function ScheduleContainer() {
  const wrapperRef = useRef(null);
  const {
    continuesAs,
    timeTable,
  } = useContextValues();

  useEffect(() => {

    // Prevent overflow: allows table scroll-x, even if container is fluid width.
    const syncWidth = () => {
      // Get block to match width
      const navBlock = document.getElementById("block-mainnavigation");

      if (navBlock && wrapperRef.current) {
        wrapperRef.current.style.width = navBlock.offsetWidth + "px";
      }
    };

    syncWidth();
    window.addEventListener("resize", syncWidth);
    return () => window.removeEventListener("resize", syncWidth);
  }, []);

  const tripIds = useMemo(() => {
    const firstStopTrips = toArray(timeTable[0]?.trips);
    return firstStopTrips.map((t) => t?.trip_id).filter(Boolean);
  }, [timeTable]);

  const routeContinuesAs = useMemo(() => {
    return [...new Set(
      tripIds
        .map((id) => continuesAs?.[id]?.route_short_name)
        .filter(Boolean)
    )];
  }, [tripIds, continuesAs]);

  const routeContinuesAsText = joinWithAnd(routeContinuesAs);

  return (
    <section className="ictapp__timetable">
      <Row>
        <Col>
          <RouteMap scope="schedule" />
          <Header scope="schedule" />

          {routeContinuesAs.length > 0 && (
            <Row className="route-continues-as-note">
              <Col>
                <strong>Please note:</strong> Some trips continue as different routes. Refer to the last row in each column to see what each trip continues as.
                {/* {routeContinuesAsText} */}
              </Col>
            </Row>
          )}

          <Row className="ictapp__timetable__table">
            <Col ref={wrapperRef}>
              <TableContainer />
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
}
